<template>
  <div class="package">
    <div class="movie-content">
      <div class="movie-card" v-for="(item,i) in list" :key="i" @click="openVideo(item)">
        <div class="movie-info">
          <div class="movie-body">
            <img :src="item.videoImg" alt="" />
            <div class="date-time">{{item.updateTime | timeNum(10)|trustTime2}}</div>
            <div class="play-btn"></div>
          </div>
          <div class="movie-footer">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list:null,
  },
  data: () => ({
  }),
  methods: {
    openVideo(item) {
      var rou = this.$router.resolve({
        path:"/articleDetail",
        query:{
          id:item.id,
          type:item.type,
        }
      });
      window.open(rou.href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./productVideo.scss";
</style>
